module.exports = __webpack_public_path__ + "media/alarm_sound.dd006437.mp3";